import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
    <footer class="relative py-16 overflow-hidden bg-blueGray-900">
    <div class="relative px-4 md:px-14 mx-auto " >
      <div class="max-w-4xl">
        <div class="flex flex-wrap -mx-4 -mb-10">
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4 mb-10">
            <h4 class="font-heading text-3xl font-medium text-gray-50 mb-8">About</h4>
            {/* <ul>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Story</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Creative Team</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Founders</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Why us</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">How we compare</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Our Mission</a></li>
              <li><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Idea</a></li>
            </ul> */}
          </div>
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4 mb-10">
            <h4 class="font-heading text-3xl font-medium text-gray-50 mb-8">Academics</h4>
            {/* <ul>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Plans</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Pricing</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Integrations</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Sign Up</a></li>
              <li><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Careers</a></li>
            </ul> */}
          </div>
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4 mb-10">
            <h4 class="font-heading text-3xl font-medium text-gray-50 mb-8">Catalog</h4>
            {/* <ul>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">LinkedIn</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Twitter</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Snapchat</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Instagram</a></li>
              <li><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Facebook</a></li>
            </ul> */}
          </div>
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4 mb-10">
            <h4 class="font-heading text-3xl font-medium text-gray-50 mb-8">Support</h4>
            {/* <ul>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">FAQ’s</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Live Chat</a></li>
              <li class="mb-2"><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Hotline +442234480171</a></li>
              <li><a class="inline-block text-2xs text-gray-200 hover:text-gray-100" href="#">Messages</a></li>
            </ul> */}
          </div>
        </div>
      </div>
      <div class="max-w-6xl mt-24 md:mt-52">
        <div class="flex flex-wrap -mx-4 -mb-2">
          <div class="px-4 mb-2"><a class="inline-block text-xs text-gray-200 hover:text-gray-100" href="#">Privacy Policy</a></div>
          <div class="px-4 mb-2"><a class="inline-block text-xs text-gray-200 hover:text-gray-100" href="#">Terms of Use</a></div>
        </div>
        <div class="mt-3 pt-4 border-t border-gray-500">
          <p class="text-xs text-gray-200">Copyright © 2025 Hamilton College of the Bahamas. All rights reserved.</p>
        </div>
      </div>
      
    </div>
  </footer>
  </>
  );
};

export default Footer;